var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 117,
    viewBox: "0 0 285 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_876_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4951,
    y: 18.3101,
    width: 248.474,
    height: 70.8798,
    rx: 35.4399,
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.7907 64.5759C95.2229 64.5759 93.7617 64.3243 92.4068 63.8211C91.0714 63.2985 89.9101 62.563 88.923 61.6147C87.9359 60.6663 87.1617 59.5534 86.6004 58.276C86.0585 56.9986 85.7875 55.5953 85.7875 54.0663C85.7875 52.5373 86.0585 51.1341 86.6004 49.8567C87.1617 48.5793 87.9359 47.4664 88.923 46.518C89.9294 45.5696 91.1004 44.8438 92.4359 44.3406C93.7713 43.818 95.2326 43.5567 96.8197 43.5567C98.581 43.5567 100.168 43.8664 101.581 44.4857C103.013 45.0857 104.213 45.976 105.181 47.1567L102.162 49.9438C101.465 49.1502 100.691 48.5599 99.839 48.1728C98.9874 47.7664 98.0584 47.5631 97.052 47.5631C96.1036 47.5631 95.2326 47.718 94.4391 48.0276C93.6455 48.3373 92.9584 48.7825 92.3778 49.3631C91.7972 49.9438 91.3423 50.6309 91.0133 51.4244C90.7036 52.2179 90.5488 53.0986 90.5488 54.0663C90.5488 55.0341 90.7036 55.9147 91.0133 56.7082C91.3423 57.5018 91.7972 58.1889 92.3778 58.7695C92.9584 59.3502 93.6455 59.7953 94.4391 60.105C95.2326 60.4147 96.1036 60.5695 97.052 60.5695C98.0584 60.5695 98.9874 60.376 99.839 59.9889C100.691 59.5824 101.465 58.9727 102.162 58.1598L105.181 60.9469C104.213 62.1276 103.013 63.0275 101.581 63.6469C100.168 64.2662 98.5713 64.5759 96.7907 64.5759ZM114.931 64.4598C113.267 64.4598 111.786 64.1114 110.489 63.4146C109.212 62.7179 108.196 61.7695 107.441 60.5695C106.705 59.3502 106.338 57.9663 106.338 56.4179C106.338 54.8502 106.705 53.4663 107.441 52.2663C108.196 51.047 109.212 50.0986 110.489 49.4212C111.786 48.7244 113.267 48.376 114.931 48.376C116.576 48.376 118.047 48.7244 119.344 49.4212C120.641 50.0986 121.657 51.0373 122.392 52.2373C123.128 53.4373 123.496 54.8308 123.496 56.4179C123.496 57.9663 123.128 59.3502 122.392 60.5695C121.657 61.7695 120.641 62.7179 119.344 63.4146C118.047 64.1114 116.576 64.4598 114.931 64.4598ZM114.931 60.7437C115.686 60.7437 116.363 60.5695 116.963 60.2211C117.563 59.8727 118.038 59.3792 118.386 58.7405C118.734 58.0824 118.909 57.3082 118.909 56.4179C118.909 55.5082 118.734 54.7341 118.386 54.0953C118.038 53.4566 117.563 52.9631 116.963 52.6147C116.363 52.2663 115.686 52.0921 114.931 52.0921C114.176 52.0921 113.499 52.2663 112.899 52.6147C112.299 52.9631 111.815 53.4566 111.447 54.0953C111.099 54.7341 110.925 55.5082 110.925 56.4179C110.925 57.3082 111.099 58.0824 111.447 58.7405C111.815 59.3792 112.299 59.8727 112.899 60.2211C113.499 60.5695 114.176 60.7437 114.931 60.7437ZM136.016 48.376C137.255 48.376 138.358 48.6276 139.326 49.1309C140.313 49.6147 141.087 50.3696 141.649 51.3954C142.21 52.4018 142.491 53.6986 142.491 55.2857V64.2275H137.962V55.9824C137.962 54.7244 137.681 53.7954 137.12 53.1954C136.578 52.5954 135.803 52.2954 134.797 52.2954C134.081 52.2954 133.433 52.4502 132.852 52.7599C132.291 53.0502 131.845 53.505 131.516 54.1244C131.207 54.7437 131.052 55.5373 131.052 56.505V64.2275H126.523V48.6083H130.849V52.9341L130.036 51.6276C130.597 50.5825 131.4 49.7792 132.445 49.218C133.491 48.6567 134.681 48.376 136.016 48.376ZM150.551 64.2275L143.99 48.6083H148.664L154.122 62.0501H151.799L157.461 48.6083H161.815L155.225 64.2275H150.551ZM170.99 64.4598C169.209 64.4598 167.641 64.1114 166.287 63.4146C164.951 62.7179 163.916 61.7695 163.18 60.5695C162.445 59.3502 162.077 57.9663 162.077 56.4179C162.077 54.8502 162.435 53.4663 163.151 52.2663C163.887 51.047 164.883 50.0986 166.141 49.4212C167.4 48.7244 168.822 48.376 170.409 48.376C171.938 48.376 173.312 48.7051 174.532 49.3631C175.77 50.0018 176.748 50.9309 177.464 52.1502C178.18 53.3502 178.538 54.7921 178.538 56.476C178.538 56.6502 178.528 56.8534 178.509 57.0857C178.49 57.2986 178.47 57.5018 178.451 57.6953H165.764V55.0534H176.07L174.329 55.8373C174.329 55.0244 174.164 54.3179 173.835 53.7179C173.506 53.1179 173.051 52.6534 172.47 52.3244C171.89 51.976 171.212 51.8018 170.438 51.8018C169.664 51.8018 168.977 51.976 168.377 52.3244C167.796 52.6534 167.341 53.1276 167.012 53.747C166.683 54.347 166.519 55.0631 166.519 55.8953V56.5921C166.519 57.4437 166.703 58.1985 167.07 58.8566C167.458 59.4953 167.99 59.9889 168.667 60.3372C169.364 60.6663 170.177 60.8308 171.106 60.8308C171.938 60.8308 172.664 60.705 173.283 60.4534C173.922 60.2018 174.503 59.8243 175.025 59.3211L177.435 61.934C176.719 62.7469 175.819 63.3759 174.735 63.8211C173.651 64.2469 172.403 64.4598 170.99 64.4598ZM181.553 64.2275V48.6083H185.879V53.0212L185.27 51.7438C185.734 50.6405 186.479 49.8083 187.505 49.247C188.531 48.6664 189.779 48.376 191.25 48.376V52.5567C191.057 52.5373 190.882 52.5276 190.728 52.5276C190.573 52.5083 190.408 52.4986 190.234 52.4986C188.995 52.4986 187.989 52.8566 187.215 53.5728C186.46 54.2695 186.082 55.3631 186.082 56.8534V64.2275H181.553ZM200.869 64.4598C199.03 64.4598 197.598 63.9953 196.572 63.0663C195.546 62.1179 195.033 60.7147 195.033 58.8566V45.1535H199.562V58.7985C199.562 59.4566 199.737 59.9695 200.085 60.3372C200.433 60.6856 200.908 60.8598 201.508 60.8598C202.224 60.8598 202.833 60.6663 203.337 60.2792L204.556 63.4727C204.091 63.8017 203.53 64.0533 202.872 64.2275C202.233 64.3824 201.566 64.4598 200.869 64.4598ZM192.624 52.4405V48.9567H203.453V52.4405H192.624Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_876_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.636 102.951H230.579C230.012 102.94 229.46 102.769 228.986 102.458C228.512 102.146 228.136 101.707 227.902 101.192L216.053 75.1548C215.625 74.0659 215.522 72.8759 215.757 71.7297C215.993 70.5835 216.557 69.5304 217.381 68.6987C218.174 67.9016 219.175 67.3439 220.27 67.0896C221.365 66.8353 222.51 66.8948 223.573 67.2611C223.665 67.2932 223.755 67.3302 223.843 67.3721L249.904 79.2096C250.417 79.446 250.853 79.8218 251.161 80.2941C251.47 80.7663 251.639 81.3159 251.649 81.8798C251.66 82.4438 251.511 82.9992 251.22 83.4824C250.929 83.9657 250.507 84.3572 250.004 84.6122L238.888 90.1647L233.33 101.27C233.083 101.774 232.7 102.198 232.224 102.495C231.747 102.792 231.197 102.95 230.636 102.951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_876_16",
    x: 0.795116,
    y: 0.610058,
    width: 283.874,
    height: 106.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_876_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_876_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_876_16",
    x: 210.94,
    y: 63.2406,
    width: 45.4045,
    height: 53.6389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_876_16"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.2349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84698
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_876_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_876_16",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.61745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84698
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_876_16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertButton);
export default __webpack_public_path__ + "static/media/convert_button.03ffe1e9825f7a11248389ed368b1e7c.svg";
export { ForwardRef as ReactComponent };